// extracted by mini-css-extract-plugin
module.exports = {"solar-energy-solutions":"B_solar-energy-solutions__8_iwO"};